import { doc } from "firebase/firestore";

import { FirestoreDocument } from "@/core/modules/firestore/objects/FirestoreDocument";
import { FirestoreModel } from "../FirestoreModel";

export const getNewId = <T extends FirestoreDocument>(model: FirestoreModel<T>, parentId?: string): string => {
  return doc(model.getPathReference(parentId)).id;
};
